import { Fab, Tooltip } from "@mui/material";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";

const PATPrintButton = (props) => {
	const { tooltipText, onClick, disabled } = props;

	const button = (
		<Fab
			disabled={disabled || false}
			size="small"
			color="secondary"
			aria-label="print"
			onClick={onClick}
		>
			<LocalPrintshopIcon />
		</Fab>
	);

	return (
		<Tooltip title={tooltipText || "Print"}>
			{disabled ? <span>{button}</span> : button}
		</Tooltip>
	);
};

export default PATPrintButton;
